export default class DateRange {

    constructor(dateFrom, dateTo) {
        this.dateFrom = dateFrom;
        this.dateTo = dateTo;
    }

    contains(date) {
        if (date != null) {
            return !( date.getTime() > this.dateTo.getTime() ||
                      ( this.dateFrom && date.getTime() < this.dateFrom.getTime() ) );
        }
    }

    isWholeMonth() {
        if (this.dateFrom.getYear() != this.dateTo.getYear())
            return false;

        if (this.dateFrom.getMonth() != this.dateTo.getMonth())
            return false;

        if (this.dateFrom.getDate() != 1)
            return false;

        let daysNumber;
        switch (this.dateFrom.getMonth()) {
            case 0:
            case 2:
            case 4:
            case 6:
            case 7:
            case 9:
            case 11:
                daysNumber = 31;
                break;
            case 3:
            case 5:
            case 8:
            case 10:
                daysNumber = 30;
                break;
            case 1:
                daysNumber = (this.dateFrom.getFullYear() % 4 == 0 && this.dateFrom.getFullYear() % 100 != 0 || this.dateFrom.getFullYear() % 400 == 0) ? 29 : 28;
                break;
        }

        return this.dateTo.getDate() == daysNumber;
    }

    isOneDay() {
        return this.dateFrom.getYear() == this.dateTo.getYear() && this.dateFrom.getMonth() == this.dateTo.getMonth() && this.dateFrom.getDate() == this.dateTo.getDate();
    }
}


// WEBPACK FOOTER //
// ./web/js/DateRange.js